import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["inputSize", "name", "id", "placeholder", "error", "error_message", "disabled", "inputClassname", "currencyInputProps", "currency", "value", "onCurrencyChange", "isDisabled", "showTitle"],
    _excluded2 = ["control"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import CurrencyInputControl from 'react-currency-input-field';
import { Controller } from 'react-hook-form';
import { useCountryStore } from '../../store/CountryStore';
import { SelectInput } from './SelectInput';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var CurrencyInput = /*#__PURE__*/forwardRef(function CurrencyInput(props, ref) {
  var _currencies$find;

  var inputSize = props.inputSize,
      name = props.name,
      id = props.id,
      placeholder = props.placeholder,
      error = props.error,
      error_message = props.error_message,
      disabled = props.disabled,
      inputClassname = props.inputClassname,
      currencyInputProps = props.currencyInputProps,
      currency = props.currency,
      value = props.value,
      onCurrencyChange = props.onCurrencyChange,
      isDisabled = props.isDisabled,
      showTitle = props.showTitle,
      passThroughProps = _objectWithoutProperties(props, _excluded);

  var focusClass = error ? 'focus-within:border-red-500 focus-within:ring-red-500 border-red-500' : 'focus-within:border-black focus-within:ring-black';

  var _useCountryStore = useCountryStore(function (_ref) {
    var state = _ref.state;
    return state;
  }),
      currencies = _useCountryStore.currencies,
      currencySelectOptionsWithCode = _useCountryStore.currencySelectOptionsWithCode;

  var currencySymbol = currencies === null || currencies === void 0 ? void 0 : (_currencies$find = currencies.find(function (curr) {
    return curr.code === currency;
  })) === null || _currencies$find === void 0 ? void 0 : _currencies$find.symbol;
  return /*#__PURE__*/_jsxs("div", {
    className: passThroughProps.className,
    children: [showTitle && !!value && /*#__PURE__*/_jsxs("p", {
      className: "text-xs font-medium",
      children: [" ", placeholder]
    }), /*#__PURE__*/_jsxs("div", {
      className: "relative flex items-center rounded-md border border-gray-300 bg-white px-1 text-sm ".concat(focusClass, " ").concat(isDisabled || disabled ? 'opacity-50' : ''),
      children: [/*#__PURE__*/_jsx("div", {
        className: "block min-w-[35px] text-center text-sm font-medium",
        children: currencySymbol
      }), /*#__PURE__*/_jsx(CurrencyInputControl, _objectSpread(_objectSpread({}, currencyInputProps), {}, {
        value: value !== null && value !== void 0 ? value : '',
        name: name,
        id: id,
        disabled: isDisabled || disabled,
        className: "numeric-font-fix peer w-full truncate border-0 pl-0 pr-2 font-sans font-medium text-gray-900 focus:outline-none focus:ring-0 ".concat(inputSize === 'sm' ? 'h-9 text-sm lg:text-base' : 'h-12', " ").concat(inputClassname),
        placeholder: placeholder // onChange={passThroughProps.onChange}
        ,
        onBlur: passThroughProps.onBlur
      })), onCurrencyChange && /*#__PURE__*/_jsx(SelectInput, {
        className: "min-w-[80px] border-0 pl-1",
        value: currency ? {
          value: currency,
          label: currency
        } : {
          value: null,
          label: 'Currency'
        },
        options: currencySelectOptionsWithCode,
        onChange: onCurrencyChange
      })]
    })]
  });
});
export var CurrencyInputControlled = function CurrencyInputControlled(_ref2) {
  var control = _ref2.control,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx(Controller, _objectSpread(_objectSpread({
    control: control
  }, props), {}, {
    render: function render(_ref3) {
      var field = _ref3.field;
      return /*#__PURE__*/_jsx(CurrencyInput, _objectSpread(_objectSpread({}, props), field));
    }
  }));
};